!(function () {
    "use strict";
    var t,
        e = {
            5592: function () {},
            6227: function (t, e, i) {
                var s = i(7367);
                const n = "onVariantChange";
                class r extends CustomEvent {}
                class a {
                    constructor(t) {
                        let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        (this.container = t),
                            (this.updateHistory = e),
                            (this.variantSelector = t.querySelector('[name="id"]')),
                            (this.elementData = t.querySelector("[data-variant-selector-data]")),
                            this.loadData(JSON.parse(this.elementData.innerHTML)),
                            this.variantSelector?.addEventListener("change", this.onInputChanged);
                    }
                    loadData(t) {
                        (this.elementData.innerHTML = JSON.stringify(t)), (this.data = t);
                    }
                    getVariantId() {
                        return parseInt(this.variantSelector?.value);
                    }
                    getVariant() {
                        const t = this.getVariantId();
                        return this.data.variants.find((e) => e.id === t);
                    }
                    setVariantId(t) {
                        if (isNaN(t) || !isFinite(t)) return;
                        if (!this.data.variants.some((e) => e.id === t)) return;
                        if (!this.variantSelector) return;
                        const e = this.getVariant();
                        (this.variantSelector.value = t.toString()),
                        this.updateHistory && (t === (0, s.variantFirstAvailableOrDefault)({ variants: this.data.variants }).id ? (0, s.queryReplaceParam)("variant", null) : (0, s.queryReplaceParam)("variant", t.toString())),
                            this.onVariantSelected();
                        const i = this.getVariant(),
                            a = new r(n, { bubbles: !0, cancelable: !1, detail: { oldVariant: e, newVariant: i, variantSelector: this } });
                        this.variantSelector.dispatchEvent(a);
                    }
                    getOptionValues() {
                        const t = {};
                        return (
                            this.data.options.forEach((e) => (t[e] = [])),
                                this.data.variants.forEach((e) => {
                                    e.options.forEach((e, i) => {
                                        const s = this.data.options[i];
                                        -1 === t[s].indexOf(e) && t[s].push(e);
                                    });
                                }),
                                t
                        );
                    }
                    setVariantOption(t, e) {
                        this.getOptionValues();
                        const i = this.getVariant(),
                            s = [];
                        for (let n = 0; n < this.data.options.length; n++) {
                            let r;
                            (r = n === t ? e : i.options[n]), s.push(r);
                        }
                        const n = this.data.variants.find((t) => t.options.every((t, e) => e >= this.data.options.length || s[e] === t));
                        return n ? (this.setVariantId(n.id), n) : null;
                    }
                    onInputChanged = (t) => {
                        this.setVariantId(parseInt(this.variantSelector.value));
                    };
                    onVariantSelected() {}
                    dispose() {
                        this.variantSelector.removeEventListener("change", this.onInputChanged);
                    }
                }
                const o = "is-active",
                    l = "is-open",
                    c = "is-hidden",
                    d = "is-disabled",
                    u = "[data-swatch]",
                    h = "[data-swatch-object]",
                    p = "[data-swatch-dropdown]",
                    m = "[data-swatch-title]",
                    f = "data-swatch-position",
                    b = "data-value",
                    v = "is-selected";
                class y extends a {
                    constructor(t, e) {
                        super(t, e),
                            (this.swatches = Array.from(t.querySelectorAll(u).values())),
                            this.container.querySelectorAll(h).forEach((t) => {
                                t.addEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(p).forEach((t) => {
                                t.addEventListener("change", this.onDropdownChange);
                            }),
                            this.onVariantSelected();
                        const i = this.container.querySelector(m);
                        i && (i.innerText = i.innerText.split("/")[0]);
                    }
                    onSwatchClick = (t) => {
                        const e = this.container.querySelectorAll(m),
                            i = t.currentTarget,
                            s = i.closest(u);
                        let n = i.querySelector("[data-image]"),
                            r = this.container.closest(".o-product-thumbnail")?.querySelector(".o-product-thumbnail__image-container");
                        if (!s) return;
                        const a = parseInt(s.getAttribute(f) || ""),
                            o = i.getAttribute(b),
                            l = i.getAttribute("data-title");
                        l &&
                        e?.forEach((t) => {
                            t.innerText = l;
                        }),
                        !isNaN(a) && o && (n && r && (r.innerHTML = n.innerHTML), this.setVariantOption(a - 1, o));
                    };
                    onDropdownChange = (t) => {
                        const e = this.container.querySelector(m),
                            i = t.currentTarget,
                            s = i.closest(u);
                        if (!s) return;
                        const n = parseInt(s.getAttribute(f) || ""),
                            r = i.options[i.selectedIndex].text;
                        r && (e.innerText = r), isNaN(n) || this.setVariantOption(n - 1, i.value);
                    };
                    onVariantSelected() {
                        const t = this.getVariant();
                        if (
                            t &&
                            (this.swatches.forEach((e) => {
                                const i = parseInt(e.getAttribute(f) || "");
                                if (isNaN(i)) return;
                                const s = t.options[i - 1];
                                e.querySelectorAll(h).forEach((t) => {
                                    if (t.getAttribute(b) === s) {
                                        t.classList.add(v);
                                        let e = t.parentElement;
                                        e && e.classList.add(v);
                                    } else {
                                        t.classList.remove(v);
                                        let e = t.parentElement;
                                        e && e.classList.remove(v);
                                    }
                                });
                                e.querySelectorAll(p).forEach((t) => (t.value = s)),
                                    e.querySelectorAll("[data-swatch-value]").forEach((t) => {
                                        t.textContent = s;
                                    });
                            }),
                                this.setDisableClass(),
                                this.container.classList.contains("o-product-thumbnail__footer"))
                        ) {
                            const e = new CustomEvent("updatePricing", { bubbles: !0, cancelable: !1, detail: { variant: t } });
                            this.container.dispatchEvent(e);
                        }
                    }
                    setDisableClass() {
                        const t = this.getVariant();
                        let e = [];
                        (e = this.data.options.length > 1 ? this.data.variants.filter((e) => e.options.includes(t.options[0]) || e.options.includes(t.options[1])) : this.data.variants.filter((t) => t.available)),
                            this.clearDisableClass(),
                            this.swatches.forEach((t) => {
                                t.querySelectorAll(h).forEach((t) => {
                                    if (!t) return;
                                    const i = t.getAttribute(b);
                                    e.some((t) => t.options.includes(i)) || t.classList.add(d);
                                });
                            });
                    }
                    clearDisableClass() {
                        this.swatches.forEach((t) => {
                            t.querySelectorAll(h).forEach((t) => {
                                t.classList.remove(d);
                            });
                        });
                    }
                    dispose() {
                        super.dispose(),
                            this.container.querySelectorAll(h).forEach((t) => {
                                t.removeEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(p).forEach((t) => {
                                t.removeEventListener("change", this.onDropdownChange);
                            });
                    }
                }
                const g = "is-disabled",
                    S = document.createElement("template");
                S.innerHTML = "\n  <slot></slot>\n";
                class E extends CustomEvent {}
                class L extends HTMLElement {
                    get value() {
                        return this.input ? this.input.valueAsNumber : this.fallbackValue;
                    }
                    set value(t) {
                        null !== this.max && (t = Math.min(this.max, t)), null !== this.min && (t = Math.max(this.min, t)), this.input && (this.input.valueAsNumber = t), (this.fallbackValue = t);
                    }
                    get min() {
                        const t = this.input ? this.input.min : this.fallbackMin;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set min(t) {
                        null === t ? (this.input && (this.input.min = ""), (this.fallbackMin = null)) : (this.input && (this.input.min = t.toString()), (this.fallbackMin = this.fallbackMin));
                    }
                    get max() {
                        const t = this.input ? this.input.max : this.fallbackMax;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set max(t) {
                        null === t ? (this.input && (this.input.max = ""), (this.fallbackMax = null)) : (this.input && (this.input.max = t.toString()), (this.fallbackMax = this.fallbackMin));
                    }
                    get disabled() {
                        return this.hasAttribute("disabled");
                    }
                    set disabled(t) {
                        t ? this.setAttribute("disabled", "disabled") : this.removeAttribute("disabled"), this.updateDisabled();
                    }
                    input = null;
                    btnMinus = null;
                    btnPlus = null;
                    line = null;
                    fallbackValue = 0;
                    fallbackMin = null;
                    fallbackMax = null;
                    constructor() {
                        super();
                        this.attachShadow({ mode: "open" }).appendChild(S.content.cloneNode(!0)),
                            (this.btnMinus = this.querySelector(".is-minus")),
                            (this.btnPlus = this.querySelector(".is-plus")),
                            (this.input = this.querySelector('input[type="number"]')),
                            this.classList.add("o-quantity-selector"),
                            (this.line = this.getAttribute("line")),
                            this.btnMinus?.addEventListener("click", this.onMinusClick),
                            this.btnPlus?.addEventListener("click", this.onPlusClick),
                            this.input?.addEventListener("change", this.onInputChanged),
                            this.updateDisabled();
                    }
                    onPlusClick = (t) => {
                        t.preventDefault(), (this.value += 1), this.onQuantityChanged();
                    };
                    onMinusClick = (t) => {
                        t.preventDefault(), (this.value -= 1), this.onQuantityChanged();
                    };
                    onInputChanged = (t) => {
                        (this.value = this.input?.valueAsNumber || this.value), this.onQuantityChanged();
                    };
                    onQuantityChanged() {
                        if (this.line)
                            try {
                                (0, s.cartChange)({ quantity: this.value, id: this.line });
                            } catch (t) {
                                console.warn(t);
                            }
                        const t = new E("onQtyChange", { bubbles: !0, cancelable: !1, detail: { qtySelector: this, newValue: this.value } });
                        this.dispatchEvent(t);
                    }
                    updateDisabled() {
                        [this.btnMinus, this.btnPlus, this.input].forEach((t) => {
                            var e;
                            this.disabled
                                ? (e = t) && ((e.disabled = !0), e.classList.add("is-disabled"))
                                : ((t) => {
                                    t && ((t.disabled = !1), t.classList.remove("is-disabled"));
                                })(t);
                        }),
                            this.disabled ? this.classList.add("is-disabled") : this.classList.remove("is-disabled");
                    }
                }
                customElements.get("quantity-selector") || customElements.define("quantity-selector", L);
                const q = "[data-label-element]",
                    A = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn"),
                    C = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn [data-label-element]");
                class _ {
                    btnAdd = null;
                    btnAddMobile = null;
                    btnAddDesktop = null;
                    qtySelector = null;
                    form = null;
                    swatches = null;
                    rechargeSubscriptionOptionsElement = null;
                    rechargeWidget = null;
                    stickyPrice = null;
                    money = null;
                    compare = null;
                    parentCarousel = null;
                    parentCarouselTiles = null;
                    adding = !1;
                    ogPrice = 0;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t), this.queryChildren(t), this.attachEvents();
                    }
                    queryChildren(t) {
                        (this.btnAdd = t.querySelector("[data-product-form-add]")),
                            (this.btnAddDesktop = this.btnAdd ? this.btnAdd.querySelector(".is-desktop") : null),
                            (this.btnAddMobile = this.btnAdd ? this.btnAdd.querySelector(".is-mobile") : null),
                            (this.qtySelector = t.querySelector("[data-product-form-qty]")),
                            (this.money = t.querySelectorAll("[data-product-money]")),
                            (this.compare = t.querySelectorAll("[data-product-compare-money]")),
                            (this.rechargeSubscriptionOptionsElement = t.querySelector("[data-product-recharge-selling-plans]")),
                            (this.stickyPrice = document.querySelector("[data-sticky-form]")),
                            (this.parentCarousel = document.querySelector("[data-product-gallery-carousel]")),
                            (this.parentCarouselTiles = document.querySelectorAll(".c-product-gallery__media-container")),
                            setTimeout(() => {
                                this.rechargeWidget = document.querySelector(".rc-widget");
                            }, 2e3);
                    }
                    onVariantChange() {
                        if (!this.swatches) return;
                        const t = this.swatches.getVariant(),
                            e = t?.id,
                            i = Array.from(this.parentCarouselTiles).find((t) => t.getAttribute("data-variant") === e.toString());
                        if ((i?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" }), void 0 === t)) return;
                        const { inventory_management: n, inventory_policy: r, inventory_quantity: a, price: o, compare_at_price: l, selling_plan_allocations: c } = t,
                            d = (0, s.cartGetQuantityOfVariant)(t.id);
                        this.qtySelector && (this.qtySelector.max = "shopify" === n && "deny" === r ? (a || 0) - d : null),
                        this.container.classList.contains("c-product-main__form") && (this.updatePriceElements(o, l), this.updateAddToCart(t), this.selectFeaturedImage(), this.updateRechargeVariant(c, o, l));
                    }
                    selectFeaturedImage() {
                        if (!this.swatches) return;
                        const t = this.swatches.getVariant().featured_media,
                            e = t?.id;
                        document.dispatchEvent(new CustomEvent("select_featured_image", { detail: e, bubbles: !0 }));
                    }
                    updateRechargeVariant(t, e, i) {
                        const n = this.container.querySelector(".recharge-subscription-widget"),
                            r = n?.querySelector(".subscription-radio"),
                            a = (n?.querySelector(".onetime-radio"), this.container.querySelector('[name="selling_plan"]')),
                            o = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            l = this.container.querySelector(".c-product-form__price"),
                            c = this.container.querySelector(".rc-selling-plans-dropdown__select");
                        0 === t.length
                            ? (this.container?.classList.remove("has-selling-plan"),
                                setTimeout(() => {
                                    a && (a.value = ""), l && (l.innerHTML = `${(0, s.printMoney)(e)}`), o && (o.innerHTML = `${(0, s.printMoney)(e)}`);
                                }, 1e3))
                            : (r.click(), a && (a.value = `${c?.value}`), this.container?.classList.add("has-selling-plan"), this.updateStickyPriceBasedOnSubscription());
                    }
                    updatePriceElements(t, e) {
                        this.money && this.money.forEach((e) => (e.innerText = (0, s.printMoney)(t))),
                        this.compare && (e ? this.compare.forEach((t) => (t.innerText = (0, s.printMoney)(e))) : this.compare.forEach((t) => (t.innerText = "")));
                        const i = document.querySelector(".subscription-radio"),
                            n = document.querySelector(".onetime-radio"),
                            r = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            a = this.container?.querySelector(".c-product-form__price");
                        i && i.classList.contains("rc-radio--active")
                            ? setTimeout(() => {
                                const e = i.querySelector(".rc-radio__label .rc-radio__price"),
                                    o = n.querySelector(".rc-radio__label");
                                let l = Number(t);
                                let discountPercentage = document.getElementById('product-discount-percentage').value;

                                discountPercentage = discountPercentage/100;
                                discountPercentage = 1 - discountPercentage;
                                if(discountPercentage <= 0){
                                    discountPercentage = 0.8;
                                }

                                if (document.getElementById('RechargeWidget_14697842311535')) {
                                    discountPercentage = 0.9;
                                }

                                (l *= discountPercentage),
                                o && (o.innerText = `One-time purchase ${(0, s.printMoney)(Number(t))}`),
                                e && (e.innerText = `${(0, s.printMoney)(Number(l))}`),
                                r && this.updatePriceValue(r, (0, s.printMoney)(Number(l))),
                                a && this.updatePriceValue(a, (0, s.printMoney)(Number(l)));
                            }, 200)
                            : (r && this.updatePriceValue(r, (0, s.printMoney)(t)), a && this.updatePriceValue(a, (0, s.printMoney)(t)));
                    }
                    updateStickyPriceBasedOnSubscription() {
                        if (!this.rechargeWidget) return;
                        this.rechargeWidget.querySelectorAll('input[type="radio"]').forEach((t) => {
                            t.addEventListener("change", () => {
                                this.updateStickyPriceElement(t);
                            }),
                            t.checked && this.updateStickyPriceElement(t);
                        });
                    }
                    updateStickyPriceElement(t) {
                        const e = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            i = this.container?.querySelector(".c-product-form__price");
                        if ("subscription" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.remove("is-one-time");
                            const n = t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price");
                            let r = n?.innerText;


                            if (document.getElementById('RechargeWidget_14697842311535')) {
                                let discountPercentage = 0.9;
                                const priceElement = document.querySelector('.subscription-radio .rc-radio__price');
                                const priceElementOnBtn = document.querySelector('.c-product-form__add-btn .c-product-form__price');
                                if (priceElement) {
                                    priceElement.textContent = '$27.00';
                                }
                                if(priceElementOnBtn) {
                                    priceElementOnBtn.textContent = '$27.00';
                                }
                            } else {

                                t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price .is-price") && (r = `${(0, s.printMoney)(Number(this.ogPrice))}`), this.updatePriceValue(e, r), this.updatePriceValue(i, r);
                            }
                        } else if ("onetime" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.add("is-one-time");
                            const t = document.querySelector("[data-product-money]"),
                                s = t?.innerText;
                            this.updatePriceValue(e, s), this.updatePriceValue(i, s);
                        }
                    }
                    updatePriceValue(t, e) {
                        setTimeout(() => {
                            t && (t.innerText = e || "");
                        }, 200);
                    }
                    updateAddToCart(t) {
                        if (!this.btnAdd) return;
                        const e = (0, s.cartGetQuantityOfVariant)(t.id),
                            { available: i, inventory_policy: n, inventory_management: r, inventory_quantity: a } = t;
                        i ? ("continue" != n && null != r && (a || 0) - e <= 0 ? this.btnAllInCart() : this.btnAvailable()) : this.btnSoldOut();
                    }
                    btnAvailable() {
                        if (this.btnAdd) {
                            if (document.body.classList.contains("c-page--product"))
                                this.btnAdd.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"))), C && (C.innerHTML = (0, s.t)("products.product.add_to_cart_pdp"));
                            else {
                                if (!this.btnAddDesktop || !this.btnAddMobile) return;
                                this.btnAddDesktop.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.quick_add"))),
                                C && (C.innerHTML = (0, s.t)("products.product.quick_add")),
                                    this.btnAddMobile.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.add_to_cart")));
                            }
                            this.btnAdd.classList.remove(d),
                                this.btnAdd.removeAttribute(g),
                                this.btnAdd.removeAttribute("disabled"),
                                (this.btnAdd.disabled = !1),
                            A && (A.classList.remove(d), A.removeAttribute(g), A.removeAttribute("disabled"), (A.disabled = !1));
                        }
                    }
                    btnAllInCart() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(d),
                            this.btnAdd.setAttribute(g, g),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.all_in_cart"))),
                        C && (C.innerHTML = (0, s.t)("products.product.all_in_cart")),
                        A && (A.classList.add(d), A.setAttribute(g, g), A.setAttribute("disabled", "")));
                    }
                    btnSoldOut() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(d),
                            this.btnAdd.setAttribute(g, g),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(q).forEach((t) => {
                                t.innerHTML = (0, s.t)("products.product.sold_out");
                            }),
                        C && (C.innerHTML = (0, s.t)("products.product.sold_out")),
                        A && (A.classList.add(d), A.setAttribute(g, g), A.setAttribute("disabled", "")));
                    }
                    btnAdded() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.added_to_cart"))),
                        C && (C.innerHTML = (0, s.t)("products.product.added_to_cart")),
                            this.btnAdd.classList.remove(d),
                            this.btnAdd.removeAttribute(g),
                            this.btnAdd.removeAttribute("disabled"),
                            (this.btnAdd.disabled = !1),
                        A && (A.classList.remove(d), A.removeAttribute(g), A.removeAttribute("disabled"), (A.disabled = !1)));
                    }
                    btnPending() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(q).forEach((t) => (t.innerHTML = (0, s.t)("products.product.cart_pending"))),
                        C && (C.innerHTML = (0, s.t)("products.product.cart_pending")),
                            (this.btnAdd.disabled = !0),
                        A && (A.disabled = !0));
                    }
                    initSwatches() {
                        (this.swatches = new y(this.container, !0)),
                            setTimeout(() => {
                                this.selectFeaturedImage();
                            }, 1e3);
                    }
                    removeInjectedSubscription() {
                        const t = document.body;
                        if (!t) return void console.error("Parent node not found");
                        new MutationObserver((t, e) => {
                            for (const i of t)
                                if ("childList" === i.type) {
                                    const t = document.querySelector("[data-widget-container-wrapper]");
                                    if (t) {
                                        (t.innerHTML = ""), e.disconnect();
                                        break;
                                    }
                                } else "attributes" === i.type && console.log(`The ${i.attributeName} attribute was modified.`);
                        }).observe(t, { attributes: !0, childList: !0, subtree: !0 });
                    }
                    attachEvents() {
                        this.initSwatches(),
                            this.container.addEventListener(n, () => this.onVariantChange()),
                            setTimeout(() => {
                                this.updateStickyPriceBasedOnSubscription(), this.updateRechargeCustomPercentage();
                            }, 2e3),
                        A &&
                        A.addEventListener("click", (t) => {
                            t.preventDefault(), t.stopPropagation();
                            let e = document.querySelector("[data-product-main] [data-product-form-add]");
                            e && e.click();
                        });
                    }
                    updateRechargeCustomPercentage() {
                        const t = document.querySelector("[data-product-main]");
                        if (!t) return;
                        const e = t.querySelectorAll(".rc-radio__subscription"),
                            i = t.querySelectorAll(".rc-radio"),
                            n = Number(t.dataset.productUnitQty || 0),
                            r = (Number(t.dataset.productComparePrice || 0), Number(t.dataset.productOgPrice || 0)),
                            a = document?.querySelectorAll(".rc-radio__price");
                        (this.customRetailPercentage = Number(t?.getAttribute("data-custom-percentage"))),
                            (this.customRetailWording = String(t?.getAttribute("data-custom-wording"))),
                            e?.forEach((t) => {
                                this.customRetailPercentage && this.customRetailPercentage > 0 && (t.innerHTML = `${(0, s.t)("products.product.custom_subscribe_save")} ${this.customRetailPercentage}% ${this.customRetailWording}`);
                            }),
                        this.customRetailPercentage &&
                        this.customRetailPercentage > 0 &&
                        a?.forEach((t) => {
                            this.ogPrice = Number(String(t.textContent).replace("$", "").replace(".", ""));
                            const e = 1 - this.customRetailPercentage / 100,
                                i = this.ogPrice / e;
                            t.innerHTML = `\n          <span class="is-price">${this.removePriceSpace((0, s.printMoney)(Number(this.ogPrice)))}</span>\n          <span class="is-compare">${this.removePriceSpace(
                                (0, s.printMoney)(Number(i))
                            )}</span>\n        `;
                        }),
                        n > 0 &&
                        i?.forEach((t) => {
                            const e = t.querySelector(".rc-radio__label");
                            if (!e) return;
                            let i = e.querySelector(".rc-radio__additional-info");
                            if ((i || ((i = document.createElement("span")), i.classList.add("rc-radio__additional-info")), t.classList.contains("subscription-radio"))) {
                                const t = e.querySelector(".rc-radio__price"),
                                    r = t?.textContent?.replace("$", "").replace(",", "").trim() || "0",
                                    a = (parseFloat(r) || 0) / n,
                                    o = e.querySelector(".rc-radio__subscription");
                                if (o) {
                                    const t = `${(0, s.printMoney)(100 * a)}/${(0, s.t)("products.product.unit")}`;
                                    (i.textContent = this.removePriceSpace(t)), o.appendChild(i);
                                }
                            } else if (t.classList.contains("onetime-radio")) {
                                if (e && e.textContent) {
                                    const t = e.textContent.match(/\$\s*\d+(\.\d{2})?/),
                                        i = t ? t[0] : "";
                                    e.textContent = e.textContent.replace(i, "").trim();
                                }
                                if (!e.querySelector(".rc-radio__label-wrapper")) {
                                    const t = document.createElement("span");
                                    for (t.classList.add("rc-radio__label-wrapper"); e.firstChild; ) t.appendChild(e.firstChild);
                                    e.appendChild(t);
                                }
                                const t = document.createElement("span");
                                t.classList.add("rc-radio__price"), (t.textContent = this.removePriceSpace((0, s.printMoney)(r))), e.appendChild(t);
                                const a = `${(0, s.printMoney)(r / n)}/${(0, s.t)("products.product.unit")}`;
                                (i.textContent = this.removePriceSpace(a)), e.querySelector(".rc-radio__label-wrapper")?.appendChild(i);
                            }
                        });
                    }
                    removePriceSpace(t) {
                        return t.replace(/\s+/g, "");
                    }
                    reinitialiseSwatches(t) {
                        this.detatchEvents(), this.swatches?.loadData(t), this.attachEvents(), this.onVariantChange();
                    }
                    detatchEvents() {
                        this.swatches?.dispose();
                    }
                }
                const T = (t, e) => {
                        let i;
                        return function () {
                            for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++) n[r] = arguments[r];
                            i && clearTimeout(i),
                                (i = setTimeout(() => {
                                    t.apply(this, n), (i = null);
                                }, e));
                        };
                    },
                    x = (t, e, i, s) => {
                        let n,
                            r,
                            a = !1,
                            l = !1;
                        e.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                a && t.preventDefault();
                            });
                        }),
                            t.addEventListener("mousedown", (e) => {
                                (l = !0), t.classList.add(o), (n = e.pageX - t.offsetLeft), (r = t.scrollLeft);
                            }),
                            t.addEventListener("mouseleave", () => {
                                (l = !1), (a = !1), t.classList.remove(o);
                            }),
                            t.addEventListener("mouseup", () => {
                                (l = !1), t.classList.remove(o), setTimeout(() => (a = !1), 500);
                            }),
                            t.addEventListener("mousemove", (e) => {
                                if (!l) return;
                                a = !0;
                                const i = 3 * (e.pageX - t.offsetLeft - n);
                                (t.scrollLeft = r - i), t.setAttribute("data-scroll-left", (r - i).toString());
                            }),
                            t.addEventListener(
                                "scroll",
                                T(() => {
                                    let n = w(t, e);
                                    s && s(w(t, e)), i && (n + 1 >= e.length && !P(t) ? (i.style.width = (1 / e.length) * 100 + "%") : P(t) ? (i.style.width = "100%") : (i.style.width = ((n + 1) / e.length) * 100 + "%"));
                                }, 50)
                            );
                    },
                    k = (t, e, i, s, n) => {
                        n && (n.style.width = (1 / e.length) * 100 + "%"),
                            s.addEventListener("click", () => {
                                let i = w(t, e);
                                if (i + 1 >= e.length || P(t)) (t.scrollLeft = 0), n && (n.style.width = (1 / e.length) * 100 + "%");
                                else {
                                    let s = 0;
                                    for (let t = 0; t <= i; t++) s += e[i].clientWidth;
                                    (t.scrollLeft = s), n && (n.style.width = ((i + 2) / e.length) * 100 + "%");
                                }
                            }),
                            i.addEventListener("click", () => {
                                let i = w(t, e);
                                if (i <= 0) (t.scrollLeft = t.scrollWidth), n && (n.style.width = "100%");
                                else {
                                    let s = 0;
                                    for (let t = 0; t < i - 1; t++) s += e[i].clientWidth;
                                    (t.scrollLeft = s), n && (n.style.width = (i / e.length) * 100 + "%");
                                }
                            });
                    },
                    w = (t, e) => {
                        let i = t.scrollLeft - 5;
                        for (let t = 0; t < e.length; t++) if (e[t].offsetLeft >= i) return t;
                        return e.length - 1;
                    },
                    P = (t) => {
                        let e = t.scrollWidth - t.clientWidth;
                        return t.scrollLeft > e - 50;
                    };
                const M = { xxsmall: "375px", xsmall: "480px", small: "750px", medium: "1100px", large: "1350px", xlarge: "1650px", xxlarge: "2000px" },
                    V = Object.entries(M).reduce((t, e) => {
                        const [i, s] = e;
                        return (t[i] = parseInt(s)), t;
                    }, {}),
                    I = (t) => window.innerWidth >= V[t] || 0,
                    N = "data-section-initialized";
                class H {
                    static registrations = {};
                    static register(t, e) {
                        const i = [];
                        return (
                            document.querySelectorAll(t).forEach((s) => {
                                if (H.isRegistered(s)) return;
                                const n = new e(s, t);
                                i.push(n), n.queryChildren(s), n.init(), n.attachEvents(s);
                            }),
                                (this.registrations[t] = e),
                                i
                        );
                    }
                    static recheck(t) {
                        const e = this.registrations[t];
                        return e ? H.register(t, e) : [];
                    }
                    static isRegistered(t) {
                        return t.hasAttribute(N);
                    }
                    constructor(t, e) {
                        if (((this.container = t), (this.selector = e), this.container.setAttribute(N, "true"), (this.shopifyContainer = this.container.parentElement), this.shopifyContainer && this.shopifyContainer.id))
                            try {
                                this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
                            } catch (t) {
                                console.warn(t);
                            }
                        this.innerHtmlObserver = null;
                    }
                    replaceContainer(t) {
                        this.container.removeAttribute(N),
                            this.detatchEvents(this.container),
                            (this.container.innerHTML = t.innerHTML),
                            this.container.setAttribute(N, "true"),
                            this.queryChildren(this.container),
                            this.init(),
                            this.attachEvents(this.container);
                    }
                    init() {}
                    onInnerHtmlMutationObserved = (t, e) => {
                        if (!t.length) return;
                        if (!this.shopifyContainer) return;
                        const [i] = t,
                            s = [];
                        i.removedNodes.forEach((t) => s.push(t));
                        -1 !== s.findIndex((t) => t === this.shopifyContainer) && (console.log("Section", this.id, "reloaded."), this.dispose(), H.recheck(this.selector));
                    };
                    dispose() {
                        this.container.removeAttribute(N), this.detatchEvents(this.container), this.innerHtmlObserver && this.innerHtmlObserver.disconnect();
                    }
                }
                const O = "[data-accordion-title]";
                class B {
                    animationSpeed = 400;
                    constructor(t) {
                        (this.el = t), (this.summary = t.querySelector(O)), (this.content = t.querySelector("[data-accordion-body]")), (this.animation = null), (this.isClosing = !1), (this.isExpanding = !1);
                    }
                    onClick(t) {
                        t && t.preventDefault(), (this.el.style.overflow = "hidden"), this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink();
                    }
                    shrink() {
                        if (!this.summary) return;
                        this.isClosing = !0;
                        const t = `${this.el.offsetHeight}px`,
                            e = `${this.summary.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate({ height: [t, e] }, { duration: this.animationSpeed, easing: "ease-out" })),
                            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
                            (this.animation.oncancel = () => (this.isClosing = !1));
                    }
                    open() {
                        (this.el.style.height = `${this.el.offsetHeight}px`), (this.el.open = !0), window.requestAnimationFrame(() => this.expand());
                    }
                    expand() {
                        if (!this.summary || !this.content) return;
                        this.isExpanding = !0;
                        const t = `${this.el.offsetHeight}px`,
                            e = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate({ height: [t, e] }, { duration: this.animationSpeed, easing: "ease-out" })),
                            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
                            (this.animation.oncancel = () => (this.isExpanding = !1));
                    }
                    onAnimationFinish(t) {
                        (this.el.open = t), (this.animation = null), (this.isClosing = !1), (this.isExpanding = !1), (this.el.style.height = this.el.style.overflow = "");
                    }
                }
                class D {
                    accordionSlideElements = null;
                    accordionSlides = [];
                    disableSize = null;
                    constructor(t, e) {
                        (this.container = t), (this.accordionSlideElements = Array.from(t.querySelectorAll("[data-accordion-slide]"))), e && (this.disableSize = e), this.attachEvents();
                    }
                    openAccordion() {
                        this.accordionSlideElements && (this.container.classList.contains(l) || (this.container.classList.add(l), this.accordionSlideElements.forEach((t) => t.setAttribute("open", "open"))));
                    }
                    closeAccordion() {
                        this.accordionSlideElements && this.container.classList.contains(l) && (this.container.classList.remove(l), this.accordionSlideElements.forEach((t) => t.removeAttribute("open")));
                    }
                    closeActiveSlides(t, e) {
                        this.accordionSlides &&
                        0 != this.accordionSlides.length &&
                        this.accordionSlides.forEach((i) => {
                            i.el != e && i.el.open && i.onClick(t);
                        });
                    }
                    onSlideClick(t, e) {
                        if (!this.accordionSlides || 0 == this.accordionSlides.length) return;
                        if (this.disableSize && I(this.disableSize)) return void t.preventDefault();
                        const i = this.accordionSlides[e];
                        i && (this.closeActiveSlides(t, i.el), i.onClick(t));
                    }
                    onResize() {
                        this.disableSize &&
                        I(this.disableSize) &&
                        this.accordionSlides.forEach((t) => {
                            t.el.open || t.onClick();
                        });
                    }
                    attachEvents() {
                        this.accordionSlideElements &&
                        this.accordionSlideElements.length > 0 &&
                        (this.accordionSlideElements.forEach((t, e) => {
                            const i = new B(t);
                            this.accordionSlides.push(i);
                            const s = t.querySelector(O);
                            s && s.addEventListener("click", (t) => this.onSlideClick(t, e));
                        }),
                        this.disableSize && (window.addEventListener("resize", () => this.onResize()), this.onResize()));
                    }
                    detachEvents() {
                        this.accordionSlideElements &&
                        this.accordionSlideElements.length > 0 &&
                        this.accordionSlideElements.forEach((t, e) => {
                            const i = t.querySelector(O);
                            i && i.removeEventListener("click", (t) => this.onSlideClick(t, e));
                        });
                    }
                }
                const $ = "[data-card-carousel-tile-video]",
                    R = "[data-card-carousel-sound-icon-default]",
                    F = "[data-card-carousel-sound-icon-mute]";
                class W extends HTMLElement {
                    carousel = null;
                    carouselTiles = null;
                    carouselPrev = null;
                    carouselNext = null;
                    carouselButtons = [this.carouselNext, this.carouselPrev];
                    autoPlayInterval = null;
                    autoplayTime = 2e3;
                    progressSegments = null;
                    soundButtons = null;
                    constructor(t) {
                        super();
                    }
                    connectedCallback() {
                        (this.carousel = this.querySelector("[data-card-carousel]")),
                            (this.carouselTiles = this.querySelectorAll("[data-card-carousel-tile]")),
                            (this.carouselPrev = this.querySelector("[data-card-carousel-prev]")),
                            (this.carouselNext = this.querySelector("[data-card-carousel-next]")),
                            (this.carouselButtons = [this.carouselNext, this.carouselPrev]),
                            (this.progressSegments = this.querySelectorAll("[data-card-carousel-progress-segment]")),
                            (this.soundButtons = this.querySelectorAll("[data-card-carousel-sound-button]")),
                            (this.debouncedScroll = T(() => this.scrollEvents, 200)),
                            this.initCarousel(),
                        null !== this.soundButtons &&
                        this.soundButtons.forEach((t) => {
                            t.addEventListener("click", () => this.toggleVideoSound(t));
                        });
                    }
                    initCarousel() {
                        null !== this.carousel &&
                        null !== this.carouselTiles &&
                        (x(this.carousel, this.carouselTiles, void 0, this.toggleVideoPlayback.bind(this)),
                        null !== this.carouselPrev && null !== this.carouselNext && k(this.carousel, this.carouselTiles, this.carouselPrev, this.carouselNext));
                    }
                    startCarousel() {
                        this.progressSegments && this.carousel?.addEventListener("scroll", () => this.debouncedScroll()),
                            this.scrollEvents(),
                            this.carouselPrev?.addEventListener("click", () => this.navigationEvents("prev")),
                            this.carouselNext?.addEventListener("click", () => this.navigationEvents("next"));
                    }
                    stopCarousel() {
                        this.autoPlayInterval && (clearInterval(this.autoPlayInterval), (this.autoPlayInterval = null)), this.carousel?.removeEventListener("scroll", () => this.debouncedScroll());
                    }
                    scrollEvents() {
                        this.rebindTimer(),
                            setTimeout(() => {
                                this.updateSlideProgress(!0, 0);
                            }, 100);
                    }
                    navigationEvents(t) {
                        let e = w(this.carousel, this.carouselTiles);
                        if (
                            (this.rebindTimer(),
                            "next" == t && ((e += 1), e == this.carouselTiles?.length && (e = 0)),
                            "prev" == t && ((e -= 1), e < 0 && (e = this.carouselTiles.length - 1)),
                                this.updateSlideProgress(!0, e),
                            this.carouselTiles?.length === e + 1)
                        ) {
                            const t = new CustomEvent("slide_end", { detail: null, bubbles: !0 });
                            this.dispatchEvent(t);
                        }
                    }
                    updateSlideProgress() {
                        let t = arguments.length > 1 ? arguments[1] : void 0;
                        !1 !== (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0])
                            ? (this.progressSegments.forEach((t) => {
                                t.classList.remove(o);
                            }),
                                this.progressSegments[t].classList.add(o))
                            : this.progressSegments.forEach((t) => {
                                t.classList.add("is-paused"), t.classList.remove(o);
                            });
                    }
                    rebindTimer() {
                        this.autoPlayInterval && clearInterval(this.autoPlayInterval);
                    }
                    toggleVideoPlayback(t) {
                        if (!this.carouselTiles) return (this.autoplayTime = 2e3), void this.rebindTimer();
                        let e = t;
                        void 0 === t && (e = w(this.carousel, this.carouselTiles));
                        const i = this.carouselTiles[e]?.querySelector($);
                        if ((i && ((this.autoplayTime = Math.floor(1e3 * i.duration)), this.rebindTimer(), i.play()), e > 0)) {
                            const t = this.carouselTiles[e - 1],
                                i = t?.querySelector($),
                                s = t?.querySelector(R),
                                n = t?.querySelector(F);
                            i && (i.pause(), (i.muted = !0), (i.currentTime = 0), s && n && (s.classList.add("hidden"), n.classList.remove("hidden")));
                        }
                    }
                    toggleVideoSound(t) {
                        const e = w(this.carousel, this.carouselTiles);
                        if (this.carouselTiles) {
                            const i = this.carouselTiles[e]?.querySelector($);
                            if (i) {
                                i.muted = !i.muted;
                                const e = t.querySelector(R),
                                    s = t.querySelector(F);
                                e && s && (e.classList.toggle("hidden", i.muted), s.classList.toggle("hidden", !i.muted));
                            }
                        }
                    }
                }
                customElements.get("card-carousel") || customElements.define("card-carousel", W);
                const z = "[data-product-gallery-carousel]",
                    j = "[data-proof-carousel]",
                    Q = "[data-carousel-next]",
                    U = "[data-carousel-prev]";
                H.register(
                    "[data-product-main]",
                    class extends H {
                        formElement = null;
                        form = null;
                        accordionElement = null;
                        accordion = null;
                        readMoreButton = null;
                        readLessButton = null;
                        soundBtn = null;
                        productVideo = null;
                        unmuteBtn = null;
                        muteBtn = null;
                        parentCarousel = null;
                        parentCarouselTiles = null;
                        parentCarouselProgress = null;
                        currentCardCarouselIndex = 0;
                        queryChildren(t) {
                            (this.formElement = t.querySelector("[data-product-form]")),
                                (this.accordionElement = t.querySelector("[data-product-accordion]")),
                                (this.readMoreButton = t.querySelector("[data-read-more-button]")),
                                (this.readLessButton = t.querySelector("[data-read-less-button]")),
                                (this.soundBtn = t.querySelector("[data-tile-sound-button]")),
                                (this.productVideo = t.querySelector("[data-product-video]")),
                                (this.unmuteBtn = t.querySelector("[data-tile-sound-icon-default]")),
                                (this.muteBtn = t.querySelector("[data-tile-sound-icon-mute]")),
                                (this.parentCarousel = t.querySelector("[data-parent-carousel]")),
                                (this.parentCarouselTiles = t.querySelectorAll("[data-parent-carousel-tile]")),
                                (this.parentCarouselProgress = t.querySelector("[data-carousel-progress]")),
                            this.parentCarouselTiles && ((this.currentCardCarouselIndex = 0), (this.cardCarousels = t.querySelectorAll("card-carousel")), this.cardCarousels && this.container.addEventListener("slide_end", () => {}));
                        }
                        attachEvents(t) {
                            const e = t.querySelector(z),
                                i = t.querySelector(j),
                                s = t.querySelectorAll("[data-pin]");
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    const i = e.currentTarget;
                                    if (i instanceof Element) {
                                        if (i.classList.contains("is-active")) return;
                                        {
                                            const e = t.getAttribute("data-pin");
                                            e && this.scrollToSlide(e),
                                                s.forEach((t) => {
                                                    t.classList.remove("is-active");
                                                }),
                                                t.classList.add("is-active");
                                        }
                                    }
                                });
                            }),
                            i && this.initCarousel(i),
                            e && this.initCarousel(e),
                            null !== this.parentCarousel && null !== this.parentCarouselTiles && x(this.parentCarousel, this.parentCarouselTiles),
                                this.playCardCarousel(!1);
                            const r = t.querySelector("[data-proof-container]");
                            if (r) {
                                const t = r.querySelector(U),
                                    e = r.querySelector(Q);
                                t?.addEventListener("click", () => {
                                    const t = document.querySelector(".c-proof-points__pin.is-active");
                                    if (t) {
                                        t.classList.remove("is-active");
                                        let e = t.previousElementSibling;
                                        for (; e && "PICTURE" === e.tagName; ) e = e.previousElementSibling;
                                        if (!e) {
                                            const t = Array.from(s);
                                            e = t[t.length - 1];
                                        }
                                        e && e.classList.add("is-active");
                                    }
                                }),
                                    e?.addEventListener("click", () => {
                                        const t = document.querySelector(".c-proof-points__pin.is-active");
                                        if (t) {
                                            t.classList.remove("is-active");
                                            let e = t.nextElementSibling;
                                            for (; e && "PICTURE" === e.tagName; ) e = e.nextElementSibling;
                                            e || (e = s[0]), e && e.classList.add("is-active");
                                        }
                                    });
                            }
                            this.formElement && ((this.form = new _(this.formElement)), this.formElement.addEventListener(n, this.onVariantChange)), this.accordionElement && (this.accordion = new D(this.accordionElement));
                            const a = document.querySelector("[data-read-more-full-content]");
                            this.readMoreButton?.addEventListener("click", (t) => {
                                t.preventDefault(), a?.classList.remove(c), this.readMoreButton?.classList.add(c), this.readLessButton?.classList.remove(c);
                            }),
                                this.readLessButton?.addEventListener("click", (t) => {
                                    t.preventDefault(), a?.classList.add(c), this.readLessButton?.classList.add(c), this.readMoreButton?.classList.remove(c);
                                }),
                                this.productVideo?.addEventListener("click", () => {
                                    const t = this.productVideo.getElementsByTagName("video");
                                    t[0].paused ? t[0].play() : t[0].pause();
                                }),
                                this.soundBtn?.addEventListener("click", (t) => {
                                    if ((t.stopImmediatePropagation(), this.soundBtn)) {
                                        this.unmuteBtn?.classList.toggle(c), this.muteBtn?.classList.toggle(c);
                                        const t = this.productVideo.getElementsByTagName("video");
                                        t[0].muted = !t[0].muted;
                                    }
                                }),
                                document.addEventListener("select_featured_image", this.selectFeaturedImage.bind(this));
                        }
                        playCardCarousel(t) {
                            !0 === t && (this.currentCardCarouselIndex = this.currentCardCarouselIndex + 1), this.cardCarousels[this.currentCardCarouselIndex] && this.cardCarousels[this.currentCardCarouselIndex].startCarousel();
                        }
                        scrollToSlide(t) {
                            const e = document.querySelector(j),
                                i = e.querySelector(`[data-media-id="${t}"]`);
                            if (i) {
                                const t = i.offsetLeft;
                                e && (e.scrollLeft = t);
                                const s = { left: t, behavior: "smooth" };
                                e?.scrollTo(s);
                            }
                        }
                        initCarousel(t) {
                            if (!t) return;
                            const e = t.parentElement,
                                i = t.querySelectorAll("[data-media-id]"),
                                s = e?.querySelector(U),
                                n = e?.querySelector(Q),
                                r = e?.querySelector("[data-gallery-carousel-progress]");
                            i && (x(t, i, r), s && n && k(t, i, s, n, r));
                        }
                        selectFeaturedImage(t) {
                            const e = document.querySelector(z),
                                i = e.querySelector(`[data-media-id="${t.detail}"]`);
                            if (i) {
                                const t = i.offsetLeft;
                                e && (e.scrollLeft = t);
                                const s = { left: t, behavior: "smooth" };
                                e?.scrollTo(s);
                            }
                        }
                        detatchEvents() {
                            this.accordion && this.accordion.detachEvents(),
                            this.form && this.form.detatchEvents(),
                            this.formElement && this.formElement.removeEventListener(n, this.onVariantChange),
                                document.removeEventListener("select_featured_image", this.selectFeaturedImage);
                        }
                        onVariantChange = (t) => {
                            const { detail: e } = t,
                                { oldVariant: i, newVariant: s } = e;
                        };
                    }
                );
            },
        },
        i = {};
    function s(t) {
        var n = i[t];
        if (void 0 !== n) return n.exports;
        var r = (i[t] = { exports: {} });
        return e[t].call(r.exports, r, r.exports, s), r.exports;
    }
    (s.m = e),
        (t = []),
        (s.O = function (e, i, n, r) {
            if (!i) {
                var a = 1 / 0;
                for (d = 0; d < t.length; d++) {
                    (i = t[d][0]), (n = t[d][1]), (r = t[d][2]);
                    for (var o = !0, l = 0; l < i.length; l++)
                        (!1 & r || a >= r) &&
                        Object.keys(s.O).every(function (t) {
                            return s.O[t](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((o = !1), r < a && (a = r));
                    if (o) {
                        t.splice(d--, 1);
                        var c = n();
                        void 0 !== c && (e = c);
                    }
                }
                return e;
            }
            r = r || 0;
            for (var d = t.length; d > 0 && t[d - 1][2] > r; d--) t[d] = t[d - 1];
            t[d] = [i, n, r];
        }),
        (s.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        })()),
        (s.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (s.j = 794),
        (function () {
            var t = { 794: 0 };
            s.O.j = function (e) {
                return 0 === t[e];
            };
            var e = function (e, i) {
                    var n,
                        r,
                        a = i[0],
                        o = i[1],
                        l = i[2],
                        c = 0;
                    if (
                        a.some(function (e) {
                            return 0 !== t[e];
                        })
                    ) {
                        for (n in o) s.o(o, n) && (s.m[n] = o[n]);
                        if (l) var d = l(s);
                    }
                    for (e && e(i); c < a.length; c++) (r = a[c]), s.o(t, r) && t[r] && t[r][0](), (t[r] = 0);
                    return s.O(d);
                },
                i = (self.webpackChunkreflect_boilerplate = self.webpackChunkreflect_boilerplate || []);
            i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
        })(),
        s.O(void 0, [4121], function () {
            return s(6227);
        });
    var n = s.O(void 0, [4121], function () {
        return s(5592);
    });
    n = s.O(n);
})();
